import React from 'react';
import { ThemedFunctor } from '@doveit/lego';
import * as styles from './PageLayoutContent.style';

export interface PageLayoutContentProps {
  addCss?: ThemedFunctor,
  children: React.ReactNode,
}

const PageLayoutContent: React.FC<PageLayoutContentProps> = ({
  addCss,
  children,
  ...rest
}) => (
  <div
    css={styles.content}
    $addCss={addCss}
    {...rest}
  >
    {children}
  </div>
);

export default PageLayoutContent;
